import { PriceDto } from './price.dto';
import { ProductDto } from './product.dto';

export class ProductDetailsDto {
  public product: ProductDto;
  public prices: PriceDto[];
}
